import { DatalistOption } from 'app/state/abstract/base.repository';

export const RestrictedContentLanguageOptions: DatalistOption[] = [
  { label: 'English', value: 0 },
  { label: 'Danish', value: 1 },
];
